module.exports = __webpack_public_path__ + "static/media/arrow-small.4fc634ad.svg";